import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Css/ExamCreateForm.css";
import profile from "./Images/Ellipse 24 (4).png";
import API_BASE from "../config/api";

const SoftwareView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [software, setSoftware] = useState(null);

  const API_BASE_URL = `${API_BASE}/`;

  const SUBSCRIPTION_TYPE_MAP = {
    1: "बेसिक",
    2: "स्टँडर्ड",
    3: "प्रो"
  };

  const DURATION_MAP = {
    6: "६ महिने",
    12: "१२ महिने",
    24: "२४ महिने"
  };

  const MEDIUM_MAP = {
    Marathi: "मराठी",
    English: "इंग्रजी"
  };

  useEffect(() => {
    if (id) {
      fetchSoftware();
    }
  }, [id]);

  const fetchSoftware = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/softwares/${id}`
      );
      setSoftware(res.data);
      console.log(res.data, 'data')
    } catch (error) {
      console.error("Failed to load software", error);
    }
  };

  if (!software) return null; // or loader

  return (
    <div className="create-exam-wrapper">
      {/* HEADER */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          सॉफ्टवेअर व्यवस्थापन &gt;&gt; <span>तपशील</span>
        </h3>

        <div className="edit-btnn">
          <button
            className="btn primaryy"
            onClick={() => navigate(`/dashboard/softwareEdit/${software.id}`)}
          >
            एडिट करा
          </button>
        </div>
      </div>

      {/* VIEW FORM */}
      <div className="create-exam-form">
        <h2>सॉफ्टवेअर तपशील</h2>

        {/* IMAGE */}
        <div className="profile-card">
          <div className="profile-img-wrapper">
            <img
              src={
                software.profilePictureUrl
                  ? `${API_BASE_URL}${software.profilePictureUrl}`
                  : profile
              }
              alt="software"
              className="profile-img"
            />
          </div>
        </div>

        {/* DETAILS */}
        <div className="form-grid">
          <div className="form-group">
            <label>सॉफ्टवेअर नाव</label>
            <input type="text" value={software.softwareName} readOnly />
          </div>

          <div className="form-group">
            <label>इयत्ता</label>
            <input type="text" value={software.standardName} readOnly />
          </div>

          <div className="form-group">
            <label>माध्यम</label>
            <input type="text" value={MEDIUM_MAP[software.medium ?? "-"]} readOnly />
          </div>

          <div className="form-group">
            <label>सबस्क्रिप्शन स्टॅंडर्ड</label>
            <input
              type="text"
              value={SUBSCRIPTION_TYPE_MAP[software.subscriptionType] ?? "-"}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>सॉफ्टवेअर किंमत</label>
            <input type="text" value={software.softwarePrice} readOnly />
          </div>

          <div className="form-group">
            <label>विद्यार्थी मर्यादा</label>
            <input type="text" value={software.studentCapacity} readOnly />
          </div>

          <div className="form-group">
            <label>सबस्क्रिप्शन कालावधी</label>
            <input
              type="text"
              value={DURATION_MAP[software.duration] ?? "-"}
              readOnly
            />
          </div>
        </div>

        {/* PAPERS SECTION */}
        <div className="paper-section">
          <h3>पेपर माहिती</h3>

          <table className="paper-table">
            <thead>
              <tr>
                <th>पेपर नंबर</th>
                <th>विषय</th>
                <th>एकूण टॉपिक्स</th>
                <th>एकूण सबटॉपिक्स</th>
              </tr>
            </thead>

            <tbody>
              {software.papers?.map((paper, index) => (
                <tr key={index}>
                  <td>{paper.paperNumber}</td>

                  {/* SUBJECT NAMES */}
                  <td>
                    {paper.subjects?.map((sub, i) => (
                      <span key={i}>
                        {sub.name}
                        {i !== paper.subjects.length - 1 && ", "}
                      </span>
                    ))}
                  </td>

                  {/* TOTAL TOPICS */}
                  <td>{paper.totalTopics}</td>

                  {/* TOTAL SUBTOPICS */}
                  <td>{paper.totalSubTopics}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SoftwareView;
